export class RefusalPaymentDto {
  ReasonRefusalPayment: string;
  DescriptionRefusalPayment: string;
  ValueRefusalPayment?: number;
}
